/**
 * Returns Tailwind rounding classes for Figma-style grouped selection.
 * Adjacent selected items merge into one visual block — rounded corners
 * only on the top of the first and bottom of the last item in a group.
 */
export function getSelectionRounding(
  isSelected: boolean,
  prevSelected: boolean,
  nextSelected: boolean,
): string {
  if (!isSelected) return 'rounded-md';
  if (prevSelected && nextSelected) return 'rounded-none';
  if (prevSelected) return 'rounded-t-none rounded-b-md';
  if (nextSelected) return 'rounded-t-md rounded-b-none';
  return 'rounded-md'; // single selected
}
